import type { CSSProperties } from 'react'

/**
 * Mốc responsive riêng của cụm "Tài khoản liên kết" (SP-005, Task 9) — Figma responsive `26:44526`,
 * khung 375px.
 *
 * 🔴 `LINKED_ACCOUNT_SHORT_MODAL_WIDTH_PX` = 375 − 16×2 (gutter 16px hai bên). Đây là nguồn DUY NHẤT
 * (cỡ đi qua prop `width` của antd `Modal`, không có biến SCSS song song) — KHÔNG khai số `343` rải
 * rác ở nơi khác. Dùng cho BA hộp thoại NGẮN:
 * "Nhận mật khẩu" (`PasswordPromptDialog` trạng thái 1 + `RevealPasswordModal` trạng thái 2),
 * "Xác nhận thay đổi" (`PasswordPromptDialog`, dùng lại từ `EditLinkedAccountModal`), "Xác nhận
 * xoá" (`DeleteLinkedAccountModal`). CHỈ áp dụng ở ≤767px (`useIsMobile()`) — ở ≥768px mỗi hộp dùng
 * cỡ desktop riêng của Figma, xem ba hằng `…_MODAL_WIDTH_PX` ngay dưới.
 */
export const LINKED_ACCOUNT_SHORT_MODAL_WIDTH_PX = 343

/**
 * Cỡ DESKTOP (≥768px) của từng loại hộp thoại — đo từ Figma desktop, KHÔNG phải số ước lượng:
 * - biểu mẫu Thêm/Sửa `26:8974`/`26:9356` rộng 800 (hai cột 368 + khe 16, lề 24);
 * - hộp nhập/hiện mật khẩu `26:9882`/`26:10050` (Nhận mật khẩu, Xác nhận thay đổi) rộng 520;
 * - xác nhận xoá `26:9714` rộng 456.
 */
export const LINKED_ACCOUNT_FORM_MODAL_WIDTH_PX = 800
export const LINKED_ACCOUNT_PROMPT_MODAL_WIDTH_PX = 520
export const LINKED_ACCOUNT_CONFIRM_MODAL_WIDTH_PX = 456

/**
 * Class chung của MỌI hộp thoại có header/footer tách bằng vạch `#e8e8e8` (Thêm, Sửa, Nhận mật khẩu,
 * Xác nhận thay đổi). Xác nhận xoá KHÔNG dùng — Figma vẽ nó không có vạch, không có nút ×.
 */
export const LINKED_ACCOUNT_DIALOG_CLASS = 'linked-account-dialog'

/** Biến thể tiêu đề 20px (Figma H4) cho hộp nhập/hiện mật khẩu — biểu mẫu giữ 24px mặc định của app. */
export const LINKED_ACCOUNT_DIALOG_PROMPT_CLASS = 'linked-account-dialog--prompt'

/** Hộp xác nhận xoá: icon trái + khối chữ, không vạch, không nút × (Figma `26:9714`). */
export const LINKED_ACCOUNT_DIALOG_CONFIRM_CLASS = 'linked-account-dialog--confirm'

/**
 * Ô Ghi chú của Thêm/Sửa TỰ GIÃN theo nội dung, tối đa 8 dòng rồi mới cuộn trong ô — ô cố định 80px
 * (Figma) cắt ghi chú dài trên sheet toàn màn mobile dù bên dưới còn trống. Sàn 80px của Figma giữ ở
 * SCSS (`min-height: 80px !important`, vì antd đặt `min-height` bằng inline style theo `minRows`).
 */
export const LINKED_ACCOUNT_NOTE_AUTO_SIZE = { minRows: 2, maxRows: 8 }

/** Class của `<Form>` Thêm/Sửa — đặt dấu `*` bắt buộc SAU nhãn như Figma (antd mặc định đặt trước). */
export const LINKED_ACCOUNT_FORM_CLASS = 'linked-account-form'

/** Class đánh dấu hộp thoại biểu mẫu (Thêm/Sửa) đang ở chế độ overlay TOÀN MÀN (≤767px). */
export const LINKED_ACCOUNT_FULLSCREEN_MODAL_CLASS = 'linked-account-modal--fullscreen'

/** Class đánh dấu lưới biểu mẫu (Thêm/Sửa) đã xuống 1 cột (≤767px). */
export const LINKED_ACCOUNT_STACKED_FORM_CLASS = 'linked-account-form--stacked'

/**
 * `style` truyền cho antd `Modal` khi ở chế độ overlay toàn màn — hằng module-level (không dựng
 * object mới mỗi lượt render), dùng chung cho `AddLinkedAccountModal`/`EditLinkedAccountModal`.
 * Khác bẫy `Drawer` (`className` rơi vào `.ant-drawer-content` bên trong `.ant-drawer-content-wrapper`)
 * — antd `Modal` đặt CẢ `className` lẫn `style`/`width` THẲNG lên chính phần tử `.ant-modal`
 * (`rc-dialog` `Panel.js`), nên không cần `styles={{ wrapper: … }}`/`rootClassName` ở đây.
 */
export const LINKED_ACCOUNT_FULLSCREEN_MODAL_STYLE: CSSProperties = {
  top: 0,
  maxWidth: '100vw',
  margin: 0,
  paddingBottom: 0,
}
